import React from 'react'
import cx from 'classnames'
import { MENU_ITEMS } from 'constants/menu'
import { RequestFreeTrialButton } from 'components/ReusableButtons'
import Dropdown from 'components/Dropdown'

const solutionMenuItems = MENU_ITEMS.filter(item => item.position === 'solution')

const DesktopLinks = ({ className, isLogged }) => {
  const options = solutionMenuItems.map(item => ({ label: item.title, href: item.url, selected: false }))

  return (
    !isLogged && (
      <div className={cx('flex items-center', className)}>
        <Dropdown
          label='Solutions'
          options={options}
          align='center'
          testId='solutions-menu'
          classes={{
            button: 'black bg-transparent hover-slate-grey active-light-slate-grey',
            chevron: ({ open, hover }) => cx(
              'black',
              {
                'slate-grey': hover,
                'light-slate-grey': open
              }
            ),
            menu: 'bg-white z5 w12-half',
            option: ({ focus }) => cx(
              'black no-underline',
              {
                'bg-casper-white': focus,
                'bg-white': !focus
              }
            )
          }}
        />
        <RequestFreeTrialButton buttonText='Free Trial' className='ma0' />
      </div>
    )
  )
}

export default DesktopLinks
